import { useSelector } from "react-redux";

import ProductTableItem from "./ProductTableItem";

const ProductsTableBody = ({ handleDelete, filter, groupProducts, setGroupProducts, localeProducts, onJoinProduct, handlePriceClick, typeCurrency }) => {
	const { products } = useSelector((state) => state.maintainers_products);
	const { estate_parent_id } = useSelector((state) => state.auth.filter);
	const selectedEstatesParentsCount = estate_parent_id ? estate_parent_id.split(",").filter(Boolean).length : 1;

	const selectProduct = (product) => {
		let newProducts = [...groupProducts];
		if (!newProducts.find((p) => Number(p.id) === Number(product.id))) {
			newProducts.push(product);
		} else {
			newProducts = newProducts.filter((p) => Number(p.id) !== Number(product.id));
		}

		setGroupProducts(newProducts);
	};

	return (
		<tbody>
			{products &&
				products.map((item, i) => {
					let checked = false;
					if (groupProducts.find((p) => Number(p.id) === Number(item.id))) {
						checked = true;
					}

					return (
						<ProductTableItem
							key={i}
							i={i}
							ListItem={item}
							selectProduct={selectProduct}
							handleDelete={handleDelete}
							filter={filter}
							checked={checked}
							groupProducts={groupProducts}
							localeProducts={localeProducts}
							onJoinProduct={onJoinProduct}
							handlePriceClick={handlePriceClick}
							typeCurrency={typeCurrency}
							selectedEstatesParentsCount={selectedEstatesParentsCount}
						/>
					);
				})}
		</tbody>
	);
};

export default ProductsTableBody;
